import { render, staticRenderFns } from "./TitleClient.vue?vue&type=template&id=26fdb2ba&scoped=true"
import script from "./TitleClient.vue?vue&type=script&lang=ts"
export * from "./TitleClient.vue?vue&type=script&lang=ts"
import style0 from "./TitleClient.vue?vue&type=style&index=0&id=26fdb2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fdb2ba",
  null
  
)

export default component.exports